import FullTable from 'js/components/full-table/index.js'
import {openModalConfirmRemoveWithPrompt, openModalAlert} from 'js/services/modals.js'
import {mapGetters} from 'vuex'

import template from './_table.pug'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    pools: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ready: false,
      showFilters: true,
      filters: {name: '', ddiNumber: '', campaignId: '', policyType: ''},
      lastQueryOptions: null, // guarda los últimos filtros aplicados,
      campaigns: []
    }
  },
  computed: {
    ...mapGetters(['policyTypes']),
    defaultOrder() {
      return {currentField: 'name', currentDir: 'asc'}
    },
    filterButtonParams() {
      if (this.showFilters) {
        return {class: 'active', icon: 'angle-up'}
      }

      return {class: '', icon: 'angle-down'}
    },

    campaignOptions() {
      return this.campaigns
    },

    policyTypeOptions() {
      return this.policyTypes.map(policyType => ({
        label: policyType.name,
        value: policyType.key
      }))
    }

  },
  created() {
    this.getCampaings()
    this.ready = true
  },

  methods: {
    getCampaings() {
      return API.campaigns.index({
        page: {number: 1, size: 1000},
        simplequery:'1'
      }).then(response => {
        this.campaigns = response.data.map(campaign => ({
          label: campaign.name,
          value: campaign.id
        }))
      })
    },

    openConfirmModal(pool) {
      openModalConfirmRemoveWithPrompt(
        this.t('confirmationModal.remove.title'),
        this.t('confirmationModal.remove.body', {name: pool.name}),
        this.t('confirmationModal.remove.okButton'),
        this.t('confirmationModal.remove.promptHelp')
      ).then(({data}) => {
        if (data !== 'yes') {
          openModalAlert(
            this.t('confirmationModal.cancel.title'),
            this.t('confirmationModal.cancel.body'),
            this.t('confirmationModal.cancel.okButton')
          )
        } else {
          this.destroy(pool)
        }
      })
    },

    t(key, options = {}) {
      return this.$t(`pool.index.${key}`, options)
    },

    destroy(object) {
      API.pool.destroy(object.id).then(() => {
        this.getData()
        this.$notifications.success(this.t('succesfullyDeleted'))
      })
    },

    getData(queryOptions) {
      // si borramos un elemento y recargamos, usamos los últimos filtros aplicados
      this.$emit('load-data', queryOptions || this.lastQueryOptions)

      if (queryOptions) this.lastQueryOptions = queryOptions
    }

  }
})
